'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('RecomendacaoCtrl', function($scope, $rootScope, $q, $uibModal,
  RecomendacoesService, LoadingService, UnidadesService, MessagesService, RecomendacaoObjectService, UsuariosService,
  ProdutoModalService, DrawPolygonsService, SafrasService, $routeParams, $location, MESSAGE_WITHOUT_PRODUCT,
  MESSAGE_INVALID_PRODUCT, DecimalsService) {
  $scope.datePickerOptions = {
    showWeeks: false
  };
  $scope.loading = true;

  $scope.openPopupData = function(popup) {
    $scope.popupData[popup] = true;
  };

  $scope.popupData = {
    openedDataInicial: false,
    openedDataFinal: false,
    format: 'dd/MM/yyyy'
  };
  $scope.isDecimalV2Enabled = DecimalsService.isDecimalV2Enabled();

  $scope.changeData = function(campoData) {
    if ($scope.recommendation.dataInicial > $scope.recommendation.dataFinal) {
      if (campoData === 'inicial') {
        $scope.recommendation.dataFinal = $scope.recommendation.dataInicial;
      } else if (campoData === 'final') {
        $scope.recommendation.dataInicial = $scope.recommendation.dataFinal;
      }
    }
  };

  const setUnidadeSelected = function(produto) {
    const unidade = produto.unidade ? (produto.unidade.descricao_padrao || produto.unidade.descricao) : null;
    produto.unidadeSelected = !unidade ? {} : UnidadesService.getMeasureUnitysFromDescription(unidade);
    if (!produto.unidadeSelected.abreviatura && unidade) {
      produto.unidadeSelected = {
        ...produto.unidade,
        conversao: 1,
        nomeSistema: produto.unidade.id,
        nomeAbreviado: `${(produto.unidade.abreviatura || '').trim().toLowerCase()}/ha`
      };
    }
    return produto;
  };

  const updateProdutoValues = function(produtos) {
    produtos.forEach(function(produto) {
      const areaTotal = +$scope.recommendation.glebas.areaTotal;

      if (areaTotal > 0) {
        const doseCalculada = $scope.isDecimalV2Enabled && +produto.dose > 0 ?
          produto.dose :
          +produto.total_area / areaTotal;
        produto.qtDose = doseCalculada;
        produto.dose = $scope.isDecimalV2Enabled ?
          DecimalsService.truncateDoseOrQuantity(doseCalculada) :
          doseCalculada;

        produto.qtTotal = $scope.isDecimalV2Enabled ?
          produto.qtTotal :
          produto.dose * areaTotal;
      } else {
        produto.qtDose = produto.dose;
        produto.qtTotal = +produto.total_area;
      }

      setUnidadeSelected(produto);
      setUnidadesProduto(produto);
    });
  };

  const setValuesSelected = function() {
    $scope.isLoadingRecommendationFromApi = true;
    resetAtividade();
    return getAtividadesPeriodo().then(function() {
      const idAtividade = $scope.recommendation.selects.atividade.id;
      $scope.recommendation.atividade = _.find($scope.atividades, { id: idAtividade }) || {};
      $scope.changeAtividade();
      $scope.glebasAtividade.forEach(function(gleba) {
        const glebaFilter = _.find($scope.recommendation.selects.glebas, { id: gleba.id }) || null;
        if (glebaFilter) {
          gleba.selected = true;
          gleba.area = Number(glebaFilter.area_total);
          gleba.order = new Date();
        }
      });
      $scope.changeGlebasAndProdutos();
      updateProdutoValues($scope.recommendation.produtos);

      $scope.glebasAtividade = _.sortBy($scope.glebasAtividade, function(item) {
        return _.findIndex($scope.recommendation.selects.glebas, (i) => i.id === item.id);
      });
    })
      .finally(function() {
        $scope.isLoadingRecommendationFromApi = false;
      });
  };

  const initializeVariables = function() {
    $scope.quantidadeTotalBloqueada = true;
    $scope.loadingSpraysGleba = 0;
    $scope.loadingInfoGleba = 0;
    $scope.recommendation = {
      taxaRemonte: 0
    };
    $scope.glebasAtividade = [];
    $scope.produtos = null;
    $scope.users = [];
    $scope.atividades = [];
    $scope.gleba = {
      selected: null
    };
    $scope.produto = {
      selected: null
    };
    $scope.pressaoUnidades = UnidadesService.getPressureUnitys();
    $scope.isLoadingRecommendationFromApi = false;
  };

  // eslint-disable-next-line complexity
  const assignRouteParams = function() {
    if (!$routeParams.recommendationParams) {
      return;
    }

    const params = JSON.parse($routeParams.recommendationParams);

    $scope.recommendation.selects = {};

    if (params.atividade) {
      $scope.recommendation.selects.atividade = { id: params.atividade };
    }
    if (params.gleba) {
      const glebas = $rootScope.currentPropriedade.glebas;
      $scope.recommendation.selects.glebas = _.filter(glebas, { id: params.gleba });
    }
    params.produtos.forEach($scope.addProduto);
    if (params.safra) {
      $scope.recommendation.safra = _.find($scope.safras, { id: params.safra });
    }
    if (params.dataInicial) {
      $scope.recommendation.dataFinal = $scope.recommendation.dataInicial = moment(params.dataInicial).startOf('day')
        .toDate();
    }
    if (params.observacao) {
      $scope.recommendation.observacao = params.observacao;
    }
    if (params.cronogramaFungicidaParameterId) {
      $scope.recommendation.cronogramaFungicidaParameterId = params.cronogramaFungicidaParameterId;
    }

    return setValuesSelected();
  };

  // eslint-disable-next-line max-lines-per-function
  const initialize = function(recommendation) {
    $scope.loading = true;
    LoadingService.showLoading();

    initializeVariables();

    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.recomendacao.canManage) {
        LoadingService.hideLoading();
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.activeHistoryRecommendations = function() {
        $scope.$emit('activateSidebar', 'recommendations');
      };

      const promises = [UsuariosService.list(), SafrasService.listAll()];
      // eslint-disable-next-line max-lines-per-function
      $q.all(promises).then(function([usuarios, safras]) {
        $scope.users = (usuarios.data.length > 0) ? usuarios.data : [];
        $scope.safras = safras.data || [];

        if ((recommendation || {}).id) {
          $scope.recommendation = RecomendacaoObjectService.convertToObject(recommendation);
          setValuesSelected();
          LoadingService.hideLoading();
          $scope.loading = false;
        } else {
          $scope.recommendation = {
            dataInicial: new Date(),
            dataFinal: new Date(),
            propriedade: $rootScope.currentPropriedade,
            safra: _.find($scope.safras, { current: true }),
            umidade: {
              minima: null,
              maxima: null
            },
            temperatura: {
              minima: null,
              maxima: null
            },
            pressao: {
              unidade: $scope.pressaoUnidades[0]
            },
            litrosMin: null,
            taxaRemonte: 0
          };
          RecomendacoesService.getValuesDefault($scope.recommendation)
            .then(function(data) {
              $scope.recommendation = data;
              $scope.changeSafra();
            })
            .then(assignRouteParams)
            .finally(() => {
              LoadingService.hideLoading();
              $scope.loading = false;
            });
        }
      }, LoadingService.hideLoading);
    }, $rootScope.errorRootInitialize);
  };

  function getAtividadesPeriodo(propriedade, forceOnlyActive = false) {
    const deferred = $q.defer();

    if ($scope.recommendation.safra) {
      LoadingService.showLoading();
      const filters = {
        safra: ($scope.recommendation.safra || {}).id
      };

      if (propriedade) {
        filters.propriedade = propriedade.id;
      }

      if (!$scope.canEdit() && !forceOnlyActive) {
        filters.ignore_open = true;
      }

      RecomendacoesService.listAtividadesPeriodo(filters).then(function(data) {
        $scope.atividades = data;
        deferred.resolve();
      }, function() {
        MessagesService.alert('Ocorreu um erro ao buscar as culturas da safra selecionada.');
        deferred.reject();
      })
        .finally(LoadingService.hideLoading);
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  }

  $scope.changeSafra = function() {
    resetAtividade();
    getAtividadesPeriodo();
  };

  function resetAtividade() {
    $scope.atividades = [];
    $scope.recommendation.atividade = null;
    $scope.changeAtividade();
  }

  $scope.changeAtividade = function() {
    $scope.glebasAtividade = [];
    if ($scope.recommendation.atividade) {
      $scope.glebasAtividade = RecomendacoesService.listGlebas(
        $scope.recommendation.atividade.glebas, $scope.recommendation.propriedade.glebas
      );
      $scope.glebasAtividade.forEach(function(gleba) {
        gleba.areaEmpreendimento = $scope.recommendation.atividade.empreendimentoGleba[gleba.id];
        gleba.areaRelacaoCampo = $scope.recommendation.atividade.relacaoCampo[gleba.id];
      });
    }
  };

  $scope.changeRemonte = function() {
    $scope.changeGlebasAndProdutos();
  };

  function getAreasDemarcadas(gleba) {
    return DrawPolygonsService.list({
      safra: $scope.recommendation.safra,
      atividade: $scope.recommendation.atividade,
      gleba: gleba,
      tipo: {
        id: 'empreendimento'
      },
      complete: true
    });
  }

  function getModalSelecaoAreaDemarcadas(areas) {
    return $uibModal.open({
      templateUrl: 'views/areas_demarcadas/selecaoarea.html',
      controller: 'SelecaoAreaDemarcadaCtrl',
      controllerAs: '$selecao',
      backdrop: 'static',
      animation: false,
      keyboard: false,
      resolve: {
        areas: () => areas
      }
    });
  }

  $scope.openModalDoseByTanque = function(recomendacao) {
    const modal = $uibModal.open({
      templateUrl: 'views/painel_propriedade/recomendacao/arredondamento-dose-por-tanque.html',
      controller: 'ArredondamentoDosePorTanqueCtrl',
      controllerAs: '$ctrl',
      windowClass: 'center-modal',
      animation: false,
      keyboard: false,
      resolve: {
        recomendacao: () => recomendacao
      }
    });

    modal.result.then(function(updatedRecomendacao) {
      if (updatedRecomendacao) {
        $scope.recommendation.produtos = updatedRecomendacao.produtos;
        $scope.recommendation.capacidadeTanque = updatedRecomendacao.capacidadeTanque;
      }
    });
  };

  // eslint-disable-next-line max-lines-per-function
  $scope.addGleba = function($select) {
    LoadingService.showLoading();
    const finish = (area, areaDemarcadaId, empreendimentoId) => {
      $scope.glebasAtividade.forEach(async function(gleba) {
        if (gleba.id === $select.id) {
          let areaAvailable = gleba.areaEmpreendimento;
          if (gleba.areaRelacaoCampo) {
            areaAvailable = gleba.areaRelacaoCampo;
          }
          if (empreendimentoId) {
            $scope.recommendation.empreendimentoId = empreendimentoId;
          }
          $scope.loadingInfoGleba = gleba.id;
          gleba.selected = true;
          gleba.area = area || areaAvailable;
          gleba.order = new Date();
          gleba.areaDemarcadaId = areaDemarcadaId;
          const params = {
            gleba: gleba.id,
            atividade: $scope.recommendation.atividade.id,
            safra: $scope.recommendation.safra.id
          };
          gleba.informacoesGleba = await RecomendacoesService.getInformacoesGleba(params);
          $scope.loadingInfoGleba = null;
          $scope.$apply();
        }
      });
      $scope.gleba.selected = null;
      $scope.changeGlebasAndProdutos();
    };

    getAreasDemarcadas($select).then(({ data }) => {
      const shouldOpenModal = data.length > 1;
      if (shouldOpenModal) {
        const modal = getModalSelecaoAreaDemarcadas(data);
        modal.result.then((area) => {
          const empreendimentoGleba = area.empreendimento.empreendimento_glebas.find(
            (empGleba) => empGleba.cd_gleba === $select.id
          );
          const empreendimentoId = area.empreendimento.id;

          finish(+empreendimentoGleba.area, area.id, empreendimentoId);
        });
      } else {
        finish();
      }
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.removeGleba = function(gleba) {
    gleba.selected = false;
    $scope.changeGlebasAndProdutos();
  };

  const changeAreaTotalProdutos = function() {
    if ($scope.isDecimalV2Enabled && $scope.isLoadingRecommendationFromApi) {
      return;
    }

    ($scope.recommendation.produtos || []).forEach(function(produto) {
      $scope.changeDose(produto);
    });
  };

  const summarizeGlebas = function(glebas) {
    const areaTotal = glebas.reduce(function(sum, gleba) {
      const area = +gleba.area || +gleba.area_total;
      return sum + Math.max(area, 0);
    }, 0);

    const areaTotalFixed = $scope.isDecimalV2Enabled ?
      DecimalsService.truncateArea(areaTotal) :
      areaTotal.toFixed(2);

    return areaTotalFixed * (($scope.recommendation.taxaRemonte / 100.0) + 1);
  };

  $scope.changeGlebasSelected = function() {
    const glebasAtividade = _.filter($scope.glebasAtividade, { selected: true });
    const stillSelectedGlebas = _.filter(
      ($scope.recommendation.glebas || {}).glebas || [],
      { selected: true }
    );

    if (stillSelectedGlebas.length) {
      $scope.glebasAtividade = _.sortBy($scope.glebasAtividade, (item) => {
        const index = _.findIndex(stillSelectedGlebas, ({ id }) => id === item.id);
        return index > -1 ? 0 : glebasAtividade.length;
      });
    }

    const glebas = glebasAtividade.length ? glebasAtividade : $scope.recommendation.selects.glebas;

    $scope.recommendation.glebas = {
      glebas: glebas,
      areaTotal: summarizeGlebas(glebas)
    };

    $scope.quantidadeTotalBloqueada = glebasAtividade.length === 0;
  };

  $scope.changeGlebasAndProdutos = function() {
    $scope.changeGlebasSelected();
    changeAreaTotalProdutos();
  };

  $scope.searchProdutos = function($select) {
    $scope.searchProduto = $select.search;
    $scope.produtos = null;
    if ($scope.searchProduto.length >= 3) {
      $scope.loadingProdutos = true;
      RecomendacoesService.listItemsBalance({
        descricao: $select.search,
        operacao_item: 'pulverizacao'
      }).then(function(data) {
        $scope.produtos = data.data || [];
      })
        .catch(function(error) {
          console.error('Erro ao buscar produtos', error);
          MessagesService.alert('Erro ao carregar produtos');
        })
        .finally(function() {
          $scope.loadingProdutos = false;
        });
    }
  };
  function calculateQuantidadeTotal(dose, areaTotal) {
    if ($scope.isDecimalV2Enabled) {
      const roundedArea = DecimalsService.truncateArea(areaTotal);
      const quantidadeTotal = DecimalsService.roundForCalculation(
        dose * roundedArea,
        DecimalsService.DECIMAL_PLACES_CALCULATION
      );
      return DecimalsService.truncateDoseOrQuantity(quantidadeTotal);
    }

    const roundedArea = +$scope.recommendation.glebas.areaTotal.toFixed(2);
    const quantidadeTotal = dose * roundedArea;
    return Number(quantidadeTotal).toFixed(4);
  }

  $scope.changeDose = function(produto) {
    if (!$scope.recommendation.glebas) {
      return;
    }

    produto.qtTotal = calculateQuantidadeTotal(produto.dose, $scope.recommendation.glebas.areaTotal);
  };

  $scope.changeQuantidadeTotal = function(produto) {
    if (!$scope.recommendation.glebas) {
      return;
    }

    const areaTotal = Math.max(+$scope.recommendation.glebas.areaTotal, 0);
    if ($scope.isDecimalV2Enabled) {
      const dose = DecimalsService.roundForCalculation(
        produto.qtTotal / areaTotal,
        DecimalsService.DECIMAL_PLACES_CALCULATION
      );
      produto.dose = DecimalsService.truncateDoseOrQuantity(dose);
    } else {
      produto.dose = Number(produto.qtTotal / areaTotal);
    }
  };

  $scope.fixDose = function(produto) {
    if ($scope.isDecimalV2Enabled && produto._doseOnFocus !== produto.dose) {
      produto.dose = DecimalsService.truncateDoseOrQuantity(produto.dose);
      $scope.changeDose(produto);
      delete produto._doseOnFocus;
    } else {
      produto.dose = +Number(produto.dose).toFixed(4);
    }
  };

  $scope.fixQuantidadeTotal = function(produto) {
    if ($scope.isDecimalV2Enabled && produto._qtTotalOnFocus !== produto.qtTotal) {
      produto.qtTotal = DecimalsService.truncateDoseOrQuantity(produto.qtTotal);
      $scope.changeQuantidadeTotal(produto);
      delete produto._qtTotalOnFocus;
    } else {
      produto.qtTotal = +Number(produto.qtTotal).toFixed(4);
    }
  };

  $scope.startEditDose = function(produto) {
    produto._doseOnFocus = +produto.dose;
  };

  $scope.startEditQuantidadeTotal = function(produto) {
    produto._qtTotalOnFocus = +produto.qtTotal;
  };

  function getAreaTotal() {
    if (!$scope.recommendation.glebas) {
      return 0;
    }

    return Math.max(+$scope.recommendation.glebas.areaTotal, 0);
  }

  $scope.addProduto = function($select) {
    if ($select && $select.id) {
      const produto = _.filter($scope.recommendation.produtos, { id: $select.id }) || [];
      if (produto && produto.length > 0) {
        MessagesService.alert('Este produto já foi inserido na recomendação atual');
      } else {
        $select.qtTotal = calculateQuantidadeTotal($select.dose, getAreaTotal());
        setUnidadeSelected($select);
        setUnidadesProduto($select);
        $scope.recommendation.produtos = ($scope.recommendation.produtos || []).concat($select);
      }
    }
    $scope.produto.selected = null;
    $scope.produtos = null;
  };

  $scope.removeProduto = function(index) {
    $scope.recommendation.produtos.splice(index, 1);
  };

  $scope.setUnidadeProduto = function($event, produto, unidade) {
    $event.preventDefault();
    produto.unidadeSelected = unidade;
  };

  function setUnidadesProduto(produto) {
    produto.unidades = UnidadesService.getUnidadesCompativeis(produto.unidadeSelected);
  }

  const validateProdutos = function() {
    const produtosOriginais = $scope.recommendation.produtos || [];

    if (produtosOriginais.length === 0) {
      return { valid: false, message: MESSAGE_WITHOUT_PRODUCT };
    }

    const MIN_QT_TOTAL_VALOR = 0.0001;

    const produtosValidos = produtosOriginais.reduce(function(result, produto) {
      if (produto.dose && produto.qtTotal >= MIN_QT_TOTAL_VALOR &&
        produto.unidadeSelected && produto.unidadeSelected.conversao) {
        result.push(produto);
      }
      return result;
    }, []);

    if (produtosValidos.length < produtosOriginais.length) {
      return { valid: false, message: MESSAGE_INVALID_PRODUCT };
    }

    $scope.recommendation.produtos = produtosValidos;
    return { valid: true };
  };

  // Grava os dados
  // eslint-disable-next-line max-lines-per-function, complexity
  const saveData = function(recommendationId) {
    $scope.loadingSave = true;
    const method = $scope.recommendation.id ? RecomendacoesService.update : RecomendacoesService.save;
    method($scope.recommendation).then(function() {
      if ($scope.isFromCronograma()) {
        $location.path('/cronograma-fungicidas');
      } else {
        $scope.$emit('activateSidebar', 'recommendations');
        $scope.$emit(EVENT_RELOAD_NOTIFICATIONS);
        $scope.$emit('reloadCalendar');
      }
      MessagesService.alert(`Recomendação ${recommendationId ? 'editada' : 'salva'} com sucesso!`);
    }, function(error) {
      console.error(
        `Não foi possível ${recommendationId ? 'editar' : 'salvar'} a recomendação! Tente novamente!`,
        error
      );
      MessagesService.alert(
        `Não foi possível ${recommendationId ? 'editar' : 'salvar'} a recomendação! Tente novamente!`
      );
    })
      .finally(function() {
        delete $scope.loadingSave;
      });
  };

  $scope.isFromCronograma = function() {
    return $routeParams.redirect === 'cronogramaFungicidas';
  };

  // Exibe a mensagem de confinação de edição e valida formulário
  // eslint-disable-next-line complexity, max-lines-per-function
  $scope.save = function(form, recommendationId) {
    if (form.$invalid) {
      return;
    }
    const glebasValidas = RecomendacoesService.validateGlebas($scope);

    if (!glebasValidas.valid) {
      MessagesService.alert(glebasValidas.message);
      return;
    }

    const statusValidacao = validateProdutos();

    if (!statusValidacao.valid) {
      MessagesService.alert(statusValidacao.message);
      return;
    }

    if ($scope.recommendation.pressao &&
      $scope.recommendation.pressao.valor &&
      !$scope.recommendation.pressao.unidade) {
      MessagesService.alert('Informe a unidade de medida para a pressão.');
      return;
    }

    if (recommendationId) {
      MessagesService.confirm('Você realmente deseja editar essa recomendação?').then(function() {
        saveData(recommendationId);
      });
      return;
    }
    saveData(recommendationId);
  };


  $scope.delete = function() {
    if ($scope.recommendation.id) {
      MessagesService.confirm('Deseja excluir a recomendação?').then(function() {
        $scope.loadingDelete = true;
        RecomendacoesService.delete($scope.recommendation.id).then(function() {
          if ($scope.history) {
            $scope.$emit('history_recommendations');
          } else {
            $scope.$emit('activateSidebar', 'recommendations');
          }
          $scope.$emit('reload_history');
          MessagesService.alert('Registro excluído com sucesso!');
        }, function() {
          MessagesService.alert('Falha ao excluir o registro.');
        })
          .finally(function() {
            delete $scope.loadingDelete;
          });
      });
    }
  };

  $scope.duplicate = function() {
    if ($scope.recommendation.id) {
      $scope.modalDuplicacao = $uibModal.open({
        templateUrl: 'views/painel_propriedade/recomendacao/_modal_duplicacao.html',
        scope: $scope
      });
    }
  };

  $scope.closeModalDuplicacao = function() {
    $scope.modalDuplicacao.close();
  };

  function clearRecommendationGlebas() {
    $scope.recommendation.glebas.glebas.forEach(function(gleba) {
      gleba.selected = false;
    });
    $scope.recommendation.glebas = {
      areaTotal: '0',
      glebas: []
    };
    $scope.recommendation.selects.glebas = [];
  }

  $scope.confirmDuplication = function(propriedade) {
    if (propriedade) {
      $scope.recommendation.propriedade = {
        id: propriedade.id,
        descricao: propriedade.descricao,
        glebas: propriedade.glebas
      };
      clearRecommendationGlebas();
      resetAtividade();
      return getAtividadesPeriodo($scope.recommendation.propriedade).then(finish);
    }

    if (!$scope.canEdit()) {
      clearRecommendationGlebas();
      resetAtividade();
      return getAtividadesPeriodo(null, true).then(finish);
    }

    finish();

    function finish() {
      $scope.recommendation.id = null;
      $scope.recommendation.status = null;
      $scope.recommendation.recomendante = _.find($scope.users, { id: $scope.$root.currentUser.id });
      $scope.recommendation.capacidadeTanque = null;
      $scope.recommendation.produtos.forEach(function(produto) {
        produto.doseByTanque = null;
      });
      $scope.modalDuplicacao.close();
      MessagesService.alert('Recomendação Duplicada com sucesso!');
    }
  };

  $scope.reject = function() {
    if ($scope.recommendation.id) {
      $scope.loadingReject = true;
      $scope.$root.rejectRecomendation(null, $scope.recommendation).then(function() {
        $scope.$emit('update_recomendacao');
        $scope.$emit('reload_history');
        MessagesService.alert('Recomendação rejeitada com sucesso!');
      })
        .finally(function() {
          delete $scope.loadingReject;
        });
    }
  };

  $scope.canReject = function() {
    return $scope.recommendation && $scope.recommendation.id &&
      $scope.recommendation.status.descricao !== 'aplicada' &&
      $scope.recommendation.situacao === 'aprovado' &&
      $rootScope.permissions.usuario.CAN_APROVE_RECOMMENDATION;
  };

  $scope.setUnidadePressao = function($event, unidade) {
    $event.preventDefault();
    $scope.recommendation.pressao.unidade = unidade;
  };

  $scope.showSpraysHistory = function(gleba) {
    if (gleba && $scope.loadingSpraysGleba !== gleba.id) {
      $scope.loadingSpraysGleba = gleba.id;

      const filters = {
        gleba: gleba,
        atividade: ($scope.recommendation.atividade || {}).id,
        safra: $scope.recommendation.safra,
        operacao: $rootScope.parametros.operacao_pulverizacao.id
      };

      RecomendacoesService.getPulverizacaoGleba(filters).then(function(data) {
        $scope.historicoAplicacoes = data.data || [];
        $scope.modalPulverizacao = $uibModal.open({
          templateUrl: 'views/painel_propriedade/recomendacao/_modal_aplicacoes.html',
          scope: $scope
        });
      }, function() {
        MessagesService.alert('Não foi possível consultar o histórico de pulverização!');
      })
        .finally(function() {
          $scope.loadingSpraysGleba = 0;
        });
    }
  };

  $scope.closeApplicationsHistory = function() {
    $scope.modalPulverizacao.close();
  };

  $scope.canEdit = function() {
    return !($scope.recommendation && $scope.recommendation.status) ||
      $scope.recommendation.status.descricao !== 'aplicada';
  };

  $scope.sortableRecommendations = {
    placeholder: 'placeholder',
    handle: '.input-group-addon, .produto-group-addon'
  };

  const recomendacaoModalParams = { operacao_item: 'pulverizacao' };

  function fetchRecomendacaoProducts(descricao) {
    const params = { ...recomendacaoModalParams, ...(descricao ? { descricao } : {}) };
    return RecomendacoesService.listItemsBalance(params)
      .then(function(data) {
        return data.data || [];
      });
  }

  function fetchRecomendacaoByIds(ids) {
    return RecomendacoesService.listItemsBalance({
      ...recomendacaoModalParams,
      item: ids.join(','),
      tipo_item: 1
    }).then(function(data) {
      return data.data || [];
    });
  }

  $scope.openProductModal = function() {
    LoadingService.showLoading();
    RecomendacoesService.listItemsBalance(recomendacaoModalParams)
      .then(function(data) {
        return ProdutoModalService.buildModalList(
          data.data, $scope.recommendation.produtos, fetchRecomendacaoByIds
        );
      })
      .then(function(fullList) {
        LoadingService.hideLoading();
        const selectedProducts = ProdutoModalService.findSelected(
          fullList, $scope.recommendation.produtos
        );
        return ProdutoModalService.open(fullList, selectedProducts, {
          fetchProducts: fetchRecomendacaoProducts
        });
      })
      .then((products) => ProdutoModalService.mergeProducts(products, $scope.recommendation.produtos))
      .then((products) => {
        products.forEach((prod) => $scope.addProduto(prod));
      })
      .catch(function(error) {
        LoadingService.hideLoading();
        if (error) {
          console.error('Erro ao buscar produtos', error);
          MessagesService.alert('Erro ao carregar produtos');
        }
      });
  };

  $scope.formatFractionalDigits = function(value) {
    if ($scope.isDecimalV2Enabled) {
      return DecimalsService.formatDoseOrQuantityForDisplay(value);
    }

    if (!value || value === '') {
      return 0;
    }

    return +String(value).replace(/(\.\d{4})\d+$/, '$1');
  };

  $scope.$on('addRecommendation', function(_event, recommendation) {
    initialize(recommendation || $scope.data);
    $scope.$root.initState = null;
  });

  $scope.$on('addRecommendation_close', function() {
    $scope.recommendation = {};
  });

  $scope.$on('update_recomendacao', function() {
    if (Object.keys($scope.recommendation).length > 0) {
      if ($scope.map) {
        $scope.activeHistoryRecommendations();
      } else {
        $scope.$emit('activateSidebar', 'recommendations');
      }
    }
  });

  $scope.$watch('recommendation.produtos', function(newValue) {
    if (Array.isArray(newValue)) {
      newValue.forEach(function(item) {
        if (!!item.dose && item.dose !== '') {
          item.doseFormatted = $scope.formatFractionalDigits(item.dose);
        }
        if (!!item.qtTotal && item.qtTotal !== '') {
          item.qtTotalFormatted = $scope.formatFractionalDigits(item.qtTotal);
        }
      });
    }
  }, true);
});
